import React, { useMemo } from 'react'
import { Flex, Spin } from 'antd'
import SubmissionsGroupCard from './SubmissionsGroupCard'
import useSubmissionGroups from './useSubmissionGroups'
import SubmissionsEmptyState from './SubmissionsEmptyState'

const SubmissionGroupsSection = () => {
    const { groups, submissions, isFetching, totalSubmissions, isPendingTransition } = useSubmissionGroups()

    // Calculate total visible submissions across all groups (after filtering)
    const visibleSubmissionsCount = useMemo(() => {
        return submissions?.length || 0
    }, [submissions])

    const submissionGroupCards = useMemo(() => {
        return groups.map(group => (
            <SubmissionsGroupCard
                key={group.id}
                id={group.id}
                title={group.title}
                colorId={group.colorId}
                totalSubmissions={totalSubmissions}
                submissions={group.submissions}
                groups={groups}
            />
        ))
    }, [groups, totalSubmissions])

    // Show empty state at section level when no submissions are visible
    // Pass totalSubmissions to distinguish between true empty vs filtered empty
    if (!isFetching && visibleSubmissionsCount === 0) {
        return <SubmissionsEmptyState totalSubmissionsBeforeFilter={totalSubmissions} />
    }

    return (
        <Spin spinning={isFetching} tip='Loading submissions...'>
            <Flex gap={16} vertical className='clusters__container' style={{ opacity: isPendingTransition ? 0.5 : 1 }}>
                {submissionGroupCards}
            </Flex>
        </Spin>
    )
}

export default SubmissionGroupsSection
